import { createSelector } from 'reselect';
import {
  ITEMS_PER_CLAIM,
  CLAIMS_IN_ONBOARDING,
  CLAIMS_PER_ROUND,
  QUESTION_COUNT_TO_MASTER_LEVEL,
  QUESTION_COUNT_TO_MASTER_FIRST_LEVEL,
} from '../../data/constants';
import * as curriculumSelectors from './curriculumSelectors';
import { getOnboarding, getLevelCount } from '../../content/curriculum';

export const isLastLevel = state => state.levelIndex === getLevelCount() - 1;

export const isLastItemInClaim = state => state.itemIndex >= ITEMS_PER_CLAIM - 1;

export const isLastClaimInLevel = state => (
  // levelIndex is -1 when in onboarding
  state.levelIndex === -1 ?
    state.claimIndex >= CLAIMS_IN_ONBOARDING - 1 :
    state.claimIndex >= CLAIMS_PER_ROUND - 1
);

export const getCurrentLevelId = state => state.levelIndex + 1;

export const getCurrentLevelIndex = state => state.levelIndex;

export const getCurrentSideIndex = state => state.levelSideIndices[state.levelIndex];

export const getCurrentClaimIndex = state => state.claimIndex;

export const getCurrentItemIndex = state => state.itemIndex;

export const getGameMode = state => state.gameMode;

export const getProgressPercentageInRound = state => state.progressAmount;

export const getResponseAttemptCount = state => state.responseAttemptCount;

export const getSelectedResponse = state => state.selectedResponse;

export const getShuffledResponseIndexes = state => state.shuffledResponseIndexes;

export const getItemIndex = state => state.itemIndex;

export const getQuestionsAnsweredThisRound = state => state.questionsAnsweredThisRound;

export const getQuestionsAnsweredCorrectlyThisRound = state => state.questionsAnsweredCorrectlyThisRound;

export const getWasIncorrectComputerAnswerInRound = state => state.wasIncorrectComputerAnswerInRound;

export const getIsIncorrectItemsFaded = state => state.isIncorrectItemsFaded;

export const getIsComputerThinking = state => state.isComputerThinking;

export const getIsOnlyRightAnswerHighlighted = state => state.isOnlyRightAnswerHighlighted;

export const getIsOnboardingFromHelpButton = state => state.isOnboardingFromHelpButton;

export const getOptionState = (state, index) => state.optionStates[index];

export const getClaimText = state => (
  getCurrentLevelIndex(state) < 0
    ? getOnboarding().text
    : getStandardClaimText(state)
);

export const getQuestionCountToMasterCurrentLevel = state => (
  getCurrentLevelIndex(state) > 0
    ? QUESTION_COUNT_TO_MASTER_LEVEL
    : QUESTION_COUNT_TO_MASTER_FIRST_LEVEL
);

const getStandardClaimText = createSelector(
  [
    getCurrentLevelIndex,
    getCurrentSideIndex,
    getCurrentClaimIndex,
  ],
  curriculumSelectors.getClaimText,
);

export const getComputerEvidenceText = createSelector(
  [
    getCurrentLevelIndex,
    getCurrentSideIndex,
    getCurrentClaimIndex,
    getCurrentItemIndex,
  ],
  curriculumSelectors.getComputerEvidenceText,
);

export const getComputerEvidenceIsCorrect = createSelector(
  [
    getCurrentLevelIndex,
    getCurrentSideIndex,
    getCurrentClaimIndex,
    getCurrentItemIndex,
  ],
  curriculumSelectors.getComputerEvidenceIsCorrect,
);

export const getUserEvidenceOptions = createSelector(
  [
    getCurrentLevelIndex,
    getCurrentSideIndex,
    getCurrentClaimIndex,
    getItemIndex,
  ],
  curriculumSelectors.getUserEvidenceOptions,
);

export const getCorrectResponse = createSelector(
  [
    getCurrentLevelIndex,
    getCurrentSideIndex,
    getCurrentClaimIndex,
    getItemIndex,
  ],
  curriculumSelectors.getCorrectResponse,
);
